/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summaryinterested1Inputs */

const en_summaryinterested1 = /** @type {(inputs: Summaryinterested1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interested`)
};

const de_summaryinterested1 = /** @type {(inputs: Summaryinterested1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interessiert`)
};

/**
* | output |
* | --- |
* | "Interested" |
*
* @param {Summaryinterested1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summaryinterested1 = /** @type {((inputs?: Summaryinterested1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summaryinterested1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summaryinterested1(inputs)
	return de_summaryinterested1(inputs)
});
export { summaryinterested1 as "summaryInterested" }